"use client";

import { createContext, useContext, type ReactNode } from "react";

import type { FeatureFlagValues } from "@/lib/feature-flags";

const FeatureFlagsContext = createContext<FeatureFlagValues>({
  videoWalkthroughs: false,
  freeTemplates: false,
});

export function FeatureFlagsProvider({ values, children }: { values: FeatureFlagValues; children: ReactNode }) {
  return <FeatureFlagsContext.Provider value={values}>{children}</FeatureFlagsContext.Provider>;
}

export function useFeatureFlags(): FeatureFlagValues {
  return useContext(FeatureFlagsContext);
}
